export const CUSTOMER_SERVICE_EMAIL = "bonjour@octopusenergy.fr"
export const EMCE_CONTACT_EMAIL = "emce@octopusenergy.fr"
